import { useEffect, useCallback, useState } from 'react';

export const useOutsideClick = (ref) => {
  const [toggle, setToggle] = useState(false);

  const handleToggle = useCallback(() => {
    setToggle((prev) => !prev);
  }, []);

  const handleClick = useCallback(
    (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setToggle(false);
      }
    },
    [ref]
  );

  useEffect(() => {
    if (toggle === true) {
      document.addEventListener('click', handleClick);

      return () => {
        document.removeEventListener('click', handleClick);
      };
    }
  }, [handleClick, toggle]);
  return [toggle, handleToggle];
};
